module.exports = __webpack_public_path__ + "static/media/attach.bdfc4a0b.svg";